// Stand-in for node:module. requireRemap.ts and extensionRequire.ts patch
// Module.prototype.require / Module._load at startup; in the web build there
// is no runtime module system to patch, so this just has to be a mutable
// object of the right shape.
function Module(id) {
    this.id = id;
    this.exports = {};
    this.filename = id;
}

Module.prototype.require = function (id) {
    throw new Error(`dynamic require('${id}') is fused off in the web build`);
};

Module._load = function (request) {
    throw new Error(`Module._load('${request}') is fused off in the web build`);
};

Module._nodeModulePaths = function () {
    return [];
};

Module._resolveFilename = function (request) {
    return request;
};

Module.createRequire = function () {
    return Module.prototype.require;
};

module.exports = Module;
module.exports.Module = Module;
module.exports.default = Module;
